"use strict";
// Shared with the frontend, which imports this to bound the textarea. Kept in
// its own module with no dependencies so pulling the limit into the browser
// bundle does not drag the service, the repo and sequelize along with it.
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_PROMPT_LENGTH = exports.MAX_FEEDBACK_LENGTH = void 0;
/** Long enough for anyone with something to say; short enough not to be a hole. */
exports.MAX_FEEDBACK_LENGTH = 5000;
/**
 * `prompt` is the question we showed, so the browser has to send it - which
 * means it is client-supplied and needs a bound of its own. Without one the
 * answer cap is decorative: put the long text in `prompt` instead. A question
 * is a sentence, so this is generous already.
 */
exports.MAX_PROMPT_LENGTH = 500;
//# sourceMappingURL=product_feedback_limits.js.map